/* eslint-disable no-console */

import { register } from 'register-service-worker'

// 检查是否为安全环境（localhost 或有效 HTTPS）
const isSecureContext = () => {
  const hostname = window.location.hostname
  // localhost 和 127.0.0.1 被认为是安全的
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return true
  }
  // 检查是否为有效的 HTTPS（非自签名证书）
  // 内网 IP 通常使用自签名证书，跳过 Service Worker 注册
  if (/^(\d{1,3}\.){3}\d{1,3}$/.test(hostname)) {
    console.log('Service Worker disabled for IP address access')
    return false
  }
  return true
}

if (process.env.NODE_ENV === 'production' && isSecureContext()) {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered () {
      console.log('Service worker has been registered.')
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      console.log('New content is downloading.')
    },
    updated () {
      console.log('New content is available; please refresh.')
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
